import { useContext, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import InputAdornment from '@mui/material/InputAdornment';

// @mui icons
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayoutLanding from "layouts/authentication/components/BasicLayoutLanding";

import AuthService from "services/auth-service";
import { AuthContext } from "context";

function Login() {
  const authContext = useContext(AuthContext);

  const [user, setUser] = useState({});
  const [credentialsErros, setCredentialsError] = useState(null);
  const [rememberMe, setRememberMe] = useState(false);

  const [inputs, setInputs] = useState({
    email: "admin@admin.com",
    password: "password",
  });

  const [errors, setErrors] = useState({
    emailError: false,
    passwordError: false,
  });

  const addUserHandler = (newUser) => setUser(newUser);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const changeHandler = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    });
  };

  const submitHandler = async (e) => {
    // check rememeber me?
    e.preventDefault();

    const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (inputs.email.trim().length === 0 || !inputs.email.trim().match(mailFormat)) {
      setErrors({ ...errors, emailError: true });
      return;
    }

    if (inputs.password.trim().length < 6) {
      setErrors({ ...errors, passwordError: true });
      return;
    }

    const newUser = { email: inputs.email, password: inputs.password };
    addUserHandler(newUser);

    // const myData = {
    //   data: {
    //     type: "token",
    //     attributes: { ...newUser },
    //   },
    // };

    const myData = {...newUser};

    try {
      const response = await AuthService.login(myData);
      authContext.login(response.access_token, response.refresh_token);
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        setCredentialsError(res.message);
      } else {
        setCredentialsError(res.errors[0].detail);
      }
    }

    return () => {
      setInputs({
        email: "",
        password: "",
      });

      setErrors({
        emailError: false,
        passwordError: false,
      });
    };
  };

  return (
    <BasicLayoutLanding>
      <Card sx={{ maxWidth: "496px",width: "100%", margin: '0 auto' }}>
        <MDBox
          variant="gradient"
          borderRadius="lg"
          coloredShadow="info"
          sx={{ background: "linear-gradient(60deg, #388e3c, #388e3c)", borderRadius: "0.2rem" }}
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="left"
        >
          <MDTypography variant="h4" fontWeight="medium" sx={{ fontSize: "14px",color: "#ffffffcc" }} mt={0}>
            Log in
          </MDTypography>
        </MDBox>
        <MDBox sx={{ padding: "15px 20px" }}>
          <MDBox component="form" role="form" method="POST" onSubmit={submitHandler}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                variant="standard"
                fullWidth
                sx={{
                  "& .MuiInput-underline:after": { borderBottomColor: "#388e3c"},
                  "& .MuiInputLabel-root.Mui-focused": { color: "#388e3c" }
                }}
                InputProps= {{ 
                  endAdornment: (
                    <InputAdornment position="end">
                      <EmailOutlinedIcon fontSize="medium"/></InputAdornment>
                  ) 
                }}
                value={inputs.email}
                name="email"
                onChange={changeHandler}
                error={errors.emailError}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                variant="standard"
                fullWidth
                name="password"
                sx= {{
                  "& .MuiInput-underline:after": { borderBottomColor: "#388e3c"},
                  "& .MuiInputLabel-root.Mui-focused": { color: "#388e3c" }
                }}
                InputProps= {{ 
                  endAdornment: (
                    <InputAdornment position="end">
                      <LockOutlinedIcon fontSize="medium"/></InputAdornment>
                  ) 
                }}
                value={inputs.password}
                onChange={changeHandler}
                error={errors.passwordError}
              />
            </MDBox>
            <MDBox mt={4} mb={1} textAlign="right">
              <MDButton
                variant="gradient"
                sx={{
                  padding: "12px 30px",
                  backgroundColor: "#388e3c",
                  color: "#ffffff",
                  borderRadius: "0.2rem",
                  "&:hover": {
                    backgroundColor: "#919191",
                    color: "#fff",
                  }
                }}
                type="submit"
              >
                login
              </MDButton>
            </MDBox>
            {credentialsErros && (
              <MDTypography variant="caption" color="error" fontWeight="light">
                {credentialsErros}
              </MDTypography>
            )}
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayoutLanding>
  );
}

export default Login;
